import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/u2.css';
import App from './App';
import { initUiThemeAndFont } from './utils/uiTheme';

// Инициализируем тему до первого рендера, чтобы избежать "мигания" (FOUC)
initUiThemeAndFont();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 